export default "__VITE_ASSET__DQLmLLw3__"